module.exports = __webpack_public_path__ + "img/121.2327da3e.jpg";